import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { updateIntl } from 'react-intl-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ScrollRoute } from './components/Analytics';

import GlobalMenu from './components/GlobalMenu';
import Footer from './components/Footer/Footer';
import BriefFooter from './components/Footer/BriefFooter';
import StylistHeader from './components/StylistHeader/StylistHeader';
import Auth from './components/Auth/Auth';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import BreadCrumbMenu from './components/BreadCrumbMenus/';

import SalonLocator from './pages/SalonLocator/SalonLocator';

import updateSiteOptions from './redux/actions/siteOptions';
import updateScreenSize from './redux/actions/updateScreenSize';
import salonSolutionList from './redux/actions/salonSolutionList';
import salonSetting from './redux/actions/salonSetting';
import homeCareItemList from './redux/actions/homeCareItemList';
import homeCareItemConcerns from './redux/actions/homeCareItemConcerns';
import userSurvey from './redux/actions/userSurvey';
import scalpCamera from './redux/actions/scalpCamera';
import stylistDiagnosis from './redux/actions/stylistDiagnosis';
import sublimicDiagnosisResult from './redux/actions/sublimicDiagnosisResult';
import sublimicDiagnosisLogics from './redux/actions/sublimicDiagnosisLogics';
import sublimicHome from './redux/actions/sublimicHome';
import customerRegistration from './redux/actions/customerRegistration';

import i18n from './i18n/i18n';

import './styles/normalize.css';
import './styles/index.css';
import './styles/font.style';
import './styles/global.style';
import { getScreenSize, throttle, errorLogger, lsGetItem, lsRemoveItem } from './utils';

class App extends React.Component {
  static defaultProps = {
    salonLocatorEnabled: true,
  };

  static propTypes = {
    error: PropTypes.shape().isRequired,
    locale: PropTypes.string.isRequired,
    location: PropTypes.shape({}).isRequired,
    match: PropTypes.shape().isRequired,
    menu: PropTypes.shape({}).isRequired,
    salonLocatorEnabled: PropTypes.bool,
    screenSize: PropTypes.number.isRequired,
    updateError: PropTypes.func.isRequired,
    updateLocale: PropTypes.func.isRequired,
    updateIntl: PropTypes.func.isRequired,
    updateSiteOptions: PropTypes.func.isRequired,
    updateScreenSize: PropTypes.func.isRequired,
    sublimicHome: PropTypes.func.isRequired,
    homeCareItemList: PropTypes.func.isRequired,
    homeCareItemConcerns: PropTypes.func.isRequired,
    updateSalonSolutionList: PropTypes.func.isRequired,
    updateSalonSetting: PropTypes.func.isRequired,
    userSurvey: PropTypes.func.isRequired,
    scalpCamera: PropTypes.func.isRequired,
    stylistDiagnosis: PropTypes.func.isRequired,
    sublimicDiagnosisResult: PropTypes.func.isRequired,
    sublimicDiagnosisLogics: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
  }

  componentWillMount = () => {
    const { locale: oldLocale, match, updateIntl, updateLocale } = this.props;
    const { locale } = match.params;
    if (oldLocale !== locale) {
      updateLocale(locale);
    } else {
      if (window.location.pathname.indexOf('/salon-locator') < 0) {
        this.loadSiteOptions();
      }
    }

    window.addEventListener('resize', this.handleScreenResize);
    this.handleScreenResize();

    updateIntl({
      locale,
      messages: i18n[locale],
    });
  };

  componentWillUpdate = () => {
    const path = window.location.pathname;
  };

  componentDidUpdate = prevProps => {
    const { locale, menu } = this.props;
    const { locale: prevLocale } = prevProps;
    if (window.location.pathname.indexOf('/salon-locator') < 0 && !menu) {
      this.loadSiteOptions();
    }
    if (locale !== prevLocale) {
      this.loadSiteOptions();
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.handleScreenResize);
  };

  handleScreenResize = throttle(() => {
    const { screenSize, updateScreenSize } = this.props;
    const newScreenSize = getScreenSize();
    if (newScreenSize !== screenSize) updateScreenSize(newScreenSize);
  });

  loadSiteOptions = () => {
    const { locale, updateError, updateSiteOptions } = this.props;

    updateSiteOptions(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  loadSalonSolutionList = () => {
    const { locale, updateError, updateSalonSolutionList } = this.props;
    updateSalonSolutionList(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  loadUpdateSalonSetting = () => {
    const { locale, updateError, updateSalonSetting } = this.props;
    updateSalonSetting(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  loadhomeCareItemList = () => {
    const { locale, updateError, homeCareItemList } = this.props;

    homeCareItemList(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  loadhomeCareItemConcerns = () => {
    const { locale, updateError, homeCareItemConcerns } = this.props;

    homeCareItemConcerns(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadUserSurvey = () => {
    const { locale, updateError, userSurvey } = this.props;
    userSurvey(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadSublimicHome = () => {
    const { locale, updateError, sublimicHome } = this.props;

    sublimicHome(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadScalpCamera = () => {
    const { locale, updateError, scalpCamera } = this.props;
    scalpCamera(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadStylistDiagnosis = () => {
    const { locale, updateError, stylistDiagnosis } = this.props;
    stylistDiagnosis(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadSublimicDiagnosisResult = () => {
    const { locale, updateError, sublimicDiagnosisResult } = this.props;
    sublimicDiagnosisResult(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  loadSublimicDiagnosisLogics = () => {
    const { locale, updateError, sublimicDiagnosisLogics } = this.props;
    sublimicDiagnosisLogics(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };
  loadCustomerRegistration = () => {
    const { locale, updateError, customerRegistration } = this.props;
    customerRegistration(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  };

  render = () => {
    const { error, locale, salonLocatorEnabled, location } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <meta property="og:locale" content={locale} />
        </Helmet>

        <Switch>
          <Route
            path="/:locale/"
            render={() => (
              <Helmet>
                <link rel="manifest" href="/manifest.json" />
              </Helmet>
            )}
          />
        </Switch>

        <Auth />
        <Route path="/" component={ScrollRoute} />

        <Switch>
          {/* Salon Locator */}
          <Route path="/:locale/salon-locator" component={props => <GlobalMenu onlyLogo {...props} />} />

          {/* Redirect Beauty Consultation */}
          <Route path="/ja_jp/beauty-consultation" exact component={() => { window.location.href = 'https://chatbot.intelliticks.com/landing/mA8zPyJSZRafDqJwv_c/playbook/614573b59fb5be0a5c02a248'; return null; }} />
          <Route path="/ja_jp/beauty-consultation/results/:id?" component={() => { window.location.href = 'https://chatbot.intelliticks.com/landing/mA8zPyJSZRafDqJwv_c/playbook/614573b59fb5be0a5c02a248'; return null; }} />
          <Route path="/:locale/beauty-consultation" exact component={() => { window.location.href = 'https://chatbot.intelliticks.com/landing/XByh3mHYmNimgTwgN_c/playbook/60a26bd7380d7b473045da2a'; return null; }} />
          <Route path="/:locale/beauty-consultation/results/:id?" component={() => { window.location.href = 'https://chatbot.intelliticks.com/landing/XByh3mHYmNimgTwgN_c/playbook/60a26bd7380d7b473045da2a'; return null; }} />

          {/* Redirect Salon Consultation */}
          <Route path="/zh_hk/salon-consultation" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/zh-Hant-HK'; return null; }} />
          <Route path="/zh_hk/salon-consultation/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/zh-Hant-HK'; return null; }} />
          <Route path="/ja_jp/salon-consultation" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/ja'; return null; }} />
          <Route path="/ja_jp/salon-consultation/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/ja'; return null; }} />
          <Route path="/ko_kr/salon-consultation" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/ko'; return null; }} />
          <Route path="/ko_kr/salon-consultation/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/ko'; return null; }} />
          <Route path="/zh_tw/salon-consultation" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/zh-Hant-TW'; return null; }} />
          <Route path="/zh_tw/salon-consultation/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/zh-Hant-TW'; return null; }} />
          <Route path="/th_th/salon-consultation" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/th'; return null; }} />
          <Route path="/th_th/salon-consultation/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/th'; return null; }} />
          <Route path="/:locale/salon-consultation" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/en'; return null; }} />
          <Route path="/:locale/salon-consultation/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/e-consultation/en'; return null; }} />

          {/* Redirect remaining routes */}
          <Route path="/en" component={() => { window.location.href = 'https://www.shiseido-professional.com/en'; return null; }} />
          <Route path="/en/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/en'; return null; }} />
          <Route path="/en_hk" component={() => { window.location.href = 'https://www.shiseido-professional.com/en-HK'; return null; }} />
          <Route path="/en_hk/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/en-HK'; return null; }} />
          <Route path="/zh_hk" component={() => { window.location.href = 'https://www.shiseido-professional.com/zh-Hant-HK'; return null; }} />
          <Route path="/zh_hk/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/zh-Hant-HK'; return null; }} />
          <Route path="/en_id" component={() => { window.location.href = 'https://www.shiseido-professional.com/id'; return null; }} />
          <Route path="/en_id/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/id'; return null; }} />
          <Route path="/ja_jp" component={() => { window.location.href = 'https://www.shiseido-professional.com/ja'; return null; }} />
          <Route path="/ja_jp/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/ja'; return null; }} />
          <Route path="/ko_kr" component={() => { window.location.href = 'https://www.shiseido-professional.com/ko'; return null; }} />
          <Route path="/ko_kr/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/ko'; return null; }} />
          <Route path="/en_my" component={() => { window.location.href = 'https://www.shiseido-professional.com/ms'; return null; }} />
          <Route path="/en_my/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/ms'; return null; }} />
          <Route path="/en_sg" component={() => { window.location.href = 'https://www.shiseido-professional.com/en-SG'; return null; }} />
          <Route path="/en_sg/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/en-SG'; return null; }} />
          <Route path="/zh_tw" component={() => { window.location.href = 'https://www.shiseido-professional.com/zh-Hant-TW'; return null; }} />
          <Route path="/zh_tw/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/zh-Hant-TW'; return null; }} />
          <Route path="/th_th" component={() => { window.location.href = 'https://www.shiseido-professional.com/th'; return null; }} />
          <Route path="/th_th/*" component={() => { window.location.href = 'https://www.shiseido-professional.com/th'; return null; }} />
        </Switch>

        <Route path="/:locale/salon-locator" exact component={SalonLocator} />

        <Route path="/:locale/salon-locator" component={BriefFooter} />
      </React.Fragment>
    );
  };
}

const mapState = state => ({
  intl: state.intl,
  locale: state.locale,
  screenSize: state.screenSize,
  salonLocatorEnabled: state.siteOptions.salonLocatorEnabled,
  menu: state.siteOptions.menu,
  error: state.error,
});

const mapDispatch = dispatch => ({
  updateError: error => dispatch({ type: 'UPDATE_ERROR', error }),
  updateIntl: intl => dispatch(updateIntl(intl)),
  updateSiteOptions: locale => dispatch(updateSiteOptions(locale)),
  updateSalonSolutionList: locale => dispatch(salonSolutionList(locale)),
  updateSalonSetting: locale => dispatch(salonSetting(locale)),
  homeCareItemList: locale => dispatch(homeCareItemList(locale)),
  homeCareItemConcerns: locale => dispatch(homeCareItemConcerns(locale)),
  userSurvey: locale => dispatch(userSurvey(locale)),
  scalpCamera: locale => dispatch(scalpCamera(locale)),
  stylistDiagnosis: locale => dispatch(stylistDiagnosis(locale)),
  sublimicDiagnosisResult: locale => dispatch(sublimicDiagnosisResult(locale)),
  sublimicDiagnosisLogics: locale => dispatch(sublimicDiagnosisLogics(locale)),
  updateScreenSize: screenSize => dispatch(updateScreenSize(screenSize)),
  updateLocale: locale => dispatch({ type: 'UPDATE_LOCALE', locale }),
  sublimicHome: locale => dispatch(sublimicHome(locale)),
  customerRegistration: locale => dispatch(customerRegistration(locale)),
});

export default connect(mapState, mapDispatch)(App);



// WEBPACK FOOTER //
// ./src/App.js